import { Injectable } from '@angular/core';
import { QuoteLiteMethod } from './../../api-methods/api-methods';
import { UrlConfig } from './../../config/url.config';
import { HttpClientService } from './../http/httpClient.service';
import { HttpHeadersService } from './../http/httpHeaders.service';
import { CommonService } from './../common/common.service';

@Injectable({
  providedIn: 'any',
})
export class QuoteLiteService {
  constructor(
    public _commonService: CommonService,
    private _httpClientService: HttpClientService,
    private _httpHeadersService: HttpHeadersService,
  ) {}

  getFinalQuoteDetails(censusGroupId = 0) {
    this._commonService.isFinalQuoteChecked = false;
    censusGroupId = this._commonService.getCurrentGroupId();
    if (censusGroupId > 0) {
      if (this._commonService.existingfinalQuoteId > 0) {
        let result: any = { QuoteId: 0, IsAnyFinalQuote: false };
        result.QuoteId = this._commonService.existingfinalQuoteId;
        result.IsAnyFinalQuote = !!this._commonService.existingIsAnyFinalQuote;
        this.getFinalQuoteSelection(result);
      } else {
        this.getFinalQuoteId(censusGroupId).subscribe(
          (result) => {
            this.getFinalQuoteSelection(result);
          },
          (error) => {
            this._commonService.isAnyFinalQuote = false;
            this._commonService.isFinalQuoteChecked = true;
          },
        );
      }
    } else {
      this._commonService.isAnyFinalQuote = false;
      this._commonService.isFinalQuoteChecked = true;
    }
  }

  private getFinalQuoteSelection(result: any) {
    if (result != null) {
      this._commonService.isAnyFinalQuote = result.IsAnyFinalQuote;
      this._commonService.finalQuoteId = result.QuoteId;
      if (result.IsAnyFinalQuote) {
        this.getFinalQuoteSelections(result.QuoteId).subscribe(
          (response: any) => {
            if (response != null) {
              this._commonService.finalQuoteSelections = response;
              this._commonService.isFinalQuoteChecked = true;
            }
          },
        );
      } else {
        this._commonService.isFinalQuoteChecked = true;
      }
    }
  }

  getFinalQuoteId(censusGroupId: number): any {
    let finalQuoteIdUrl = `${UrlConfig.quoteLiteApiBaseUrl}${QuoteLiteMethod.GetFinalQuoteId}`;
    finalQuoteIdUrl = finalQuoteIdUrl.replace(
      '{censusGroupId}',
      censusGroupId.toString(),
    );
    return this._httpClientService.get<any>(
      finalQuoteIdUrl,
      this._httpHeadersService.getQuoteLiteHttpOptions(),
    );
  }

  getFinalQuoteSelections(quoteId: number): any {
    let finalQuoteSelectionsUrl = `${UrlConfig.quoteLiteApiBaseUrl}${QuoteLiteMethod.GetFinalQuoteSelections}`;
    finalQuoteSelectionsUrl = finalQuoteSelectionsUrl.replace(
      '{quoteId}',
      quoteId.toString(),
    );
    return this._httpClientService.get<any>(
      finalQuoteSelectionsUrl,
      this._httpHeadersService.getQuoteLiteHttpOptions(),
    );
  }

  getQuoteStatus(quoteId: number): any {
    let quoteStatusUrl = `${UrlConfig.quoteLiteApiBaseUrl}${QuoteLiteMethod.GetQuoteStatus}`;
    quoteStatusUrl = quoteStatusUrl.replace('{quoteId}', quoteId.toString());
    return this._httpClientService.get<any>(
      quoteStatusUrl,
      this._httpHeadersService.getQuoteLiteHttpOptions(),
    );
  }

  saveAndGetContributionModel() {
    let getContributionUrl = `${UrlConfig.quoteLiteApiBaseUrl}${QuoteLiteMethod.GetContributionDetail}`;
    return this._httpClientService.post<any>(
      getContributionUrl,
      JSON.stringify(this._commonService.bundle),
      this._httpHeadersService.getQuoteLiteHttpOptions(),
    );
  }
}
